<template>
  <div class="industry-report-view" style="padding: 40px 0;" v-loading="loading">
    <el-card :body-style="{ padding: '40px' }">
      <div class="base-info mb26">
        <div class="report-title flex jbetween astart mb26">
          <div class="report-title-val font-28">{{ reportData.reportName }}</div>
          <el-button type="primary" round size="medium" @click="handleDownload">{{ $t('downloadReport') }}</el-button>
        </div>
        <div class="report-time font-12 color-6">{{ reportData.createTime }}</div>
      </div>
      <div class="report-content">
        <bsp-pdf-preview :pdf-src="reportData.reportFilePath"></bsp-pdf-preview>
      </div>
    </el-card>
  </div>
</template>

<script>
  import BspPdfPreview from '@/components/bsp/bsp-pdf-preview/bsp-pdf-preview';
  import * as api from '@/api/policy/policyLibrary';
  import { downloadFileByUrl } from '@/util/util';
  export default {
    name: "IndustryReportView",
    components: {
      BspPdfPreview
    },
    data() {
      return {
        loading: true,
        reportData: {}
      }
    },
    created() {
      this.getData();
    },
    methods: {
      handleDownload(){
        const { fileName, reportFilePath } = this.reportData;
        downloadFileByUrl(reportFilePath, fileName);
      },
      // 获取列表
      getData() {
        let params = {
          id: this.$route.query.id
        }
        api.reportDetail(params)
          .then(res => {
            this.loading = false;
            this.reportData = res.data.data;
          })
          .catch(error => {
            this.loading = false;
          })
      }
    }
  }
</script>

<style scoped>

</style>
